import api from '@app/api/routes/api';
import type { GetMyPermissionsResponse, GetPermissionCategoriesResponse } from './permissions.types';

/**
 * Récupère les catégories de permissions avec leurs permissions embarquées.
 * Accessible uniquement aux admin link.
 */
export const getPermissionCategories = async (): Promise<GetPermissionCategoriesResponse> => {
  return api.get<GetPermissionCategoriesResponse>('/mce/permission-categories');
};

/**
 * Récupère les permissions distinctes de l'utilisateur connecté
 * (à travers toutes ses fonctions actives).
 */
export const getMyPermissions = async (): Promise<GetMyPermissionsResponse> => {
  return api.get<GetMyPermissionsResponse>('/mce/my-permissions');
};
